import React, { FunctionComponent } from 'react'
import ComparisonResultRow from '../../../entities/ComparisonResultRow'
import NoEquipmentIcon from '../../../assets/media/icons/no-equipment.svg'
import EmptyDotIcon from '../../../assets/media/icons/empty-dot.svg'
import FilledDotIcon from '../../../assets/media/icons/filled-dot.svg'
import useTranslation from '../../../hooks/useTranslation'
import tableStyle from '../comparison-pdf-table/comparisonPdfTable.css'

export type Props = {
    row: ComparisonResultRow
}

const ComparisonPdfTableRow: FunctionComponent<Props> = ({ row }) => {
    const { t } = useTranslation()
    const rowName = t('compare.rows.' + row.id, row.name)

    return (
        <tr key={row.id} className={row.comparability === 'DIFFERENT' ? tableStyle.resultRowDifferent : ''}>
            <td dangerouslySetInnerHTML={{ __html: rowName }} />
            {row.columns.map((column, index) => {
                if (column.type === 'TEXT') {
                    return (
                        <td
                            key={`${row.id}_${index}`}
                            className={tableStyle.textCell}
                            dangerouslySetInnerHTML={{ __html: column.value }}
                        />
                    )
                }

                const columnTypeMap = {
                    EXTRA: <EmptyDotIcon />,
                    STANDARD: <FilledDotIcon />,
                    UNAVAILABLE: <NoEquipmentIcon />,
                }

                return (
                    <td key={`${row.id}_${index}`} className={tableStyle.iconCell}>
                        {columnTypeMap[column.type]}
                    </td>
                )
            })}
        </tr>
    )
}

export default ComparisonPdfTableRow
